import React from 'react';
import { useTranslation } from '../../i18n';
import logicalReasoningIcon from '@public/icons/culture-fit/logic-icon200x200_v01.png';
import numericReasoningIcon from '@public/icons/culture-fit/numeric-icon200x200_v01.png';
import verbalReasoningIcon from '@public/icons/culture-fit/verbal-icon200x200_v01.png';
import CognitiveAbilitiesCategory from '../../components/CognitiveAbilitiesCategory';
import generalKnowledgeIcon from '@public/icons/culture-fit/gen-knowledge-icon200x200_v01.png';

const CognitiveAbilitiesCategoriesExplanations = () => {
    const { t } = useTranslation();

    return (
        <>
            <br></br>
            <CognitiveAbilitiesCategory
                title={t(
                    'COGNITIVE_ABILITIES.CATEGORIES.GENERAL_KNOWLEDGE_TITLE',
                )}
                description={t(
                    'COGNITIVE_ABILITIES.CATEGORIES.GENERAL_KNOWLEDGE_PARAGRAPH',
                )}
                icon={generalKnowledgeIcon}
            />
            <br></br>
            <CognitiveAbilitiesCategory
                title={t(
                    'COGNITIVE_ABILITIES.CATEGORIES.LOGICAL_REASONING_TITLE',
                )}
                description={t(
                    'COGNITIVE_ABILITIES.CATEGORIES.LOGICAL_REASONING_PARAGRAPH',
                )}
                icon={logicalReasoningIcon}
            />
            <br></br>
            <CognitiveAbilitiesCategory
                title={t(
                    'COGNITIVE_ABILITIES.CATEGORIES.NUMERIC_REASONING_TITLE',
                )}
                description={t(
                    'COGNITIVE_ABILITIES.CATEGORIES.NUMERIC_REASONING_PARAGRAPH',
                )}
                icon={numericReasoningIcon}
            />
            <br></br>
            <CognitiveAbilitiesCategory
                title={t(
                    'COGNITIVE_ABILITIES.CATEGORIES.VERBAL_REASONING_TITLE',
                )}
                description={t(
                    'COGNITIVE_ABILITIES.CATEGORIES.VERBAL_REASONING_PARAGRAPH',
                )}
                icon={verbalReasoningIcon}
            />
        </>
    );
};

export default CognitiveAbilitiesCategoriesExplanations;
